export const RoutesMigrated = {
    'loading': false,
    'callback': false,
    'schedule': true,
    'tutorial': false,
    'help': false,
    'report-problem': false,
    'schedule-details': true,
    'register-meeting': true,
    'cancel-meeting': false,
    'reschedule': false,
    'error': false,
    'offline': false,
    'report-success': false,
    'promotion-page': false,
    'sale-screen': false,
    'schedule-details.subscribers': true,
    'schedule-details.justification': true,
    'schedule-details.observation': true,
    'register-meeting.contents': true,
    'register-meeting.justification': true,
    'register-meeting.observation': true
}